// fix chart.js tooltip font color bug:

let superDrawBody = Chart.Tooltip.prototype.drawBody;

function mergeOpacity(colorString, opacity) {
    var color = Chart.helpers.color(colorString);
    return color.alpha(opacity * color.alpha()).rgbaString();
}

Chart.Tooltip.prototype.drawBody = (pt, vm, ctx, opacity) => {
    let helpers = Chart.helpers;

    let bodyFontSize = vm.bodyFontSize;
    let bodySpacing = vm.bodySpacing;
    let body = vm.body;

    ctx.textAlign = vm._bodyAlign;
    ctx.textBaseline = 'top';
    ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

    // Before Body
    let xLinePadding = 0;
    let fillLineOfText = function(line) {
        ctx.fillText(line, pt.x + xLinePadding, pt.y);
        pt.y += bodyFontSize + bodySpacing;
    };

    // Before body lines
    helpers.each(vm.beforeBody, fillLineOfText);

    let drawColorBoxes = vm.displayColors;
    xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;

    // Draw body lines now
    helpers.each(body, function(bodyItem, i) {
        helpers.each(bodyItem.before, fillLineOfText);

        helpers.each(bodyItem.lines, function(line) {
            // Draw Legend-like boxes if needed
            if (drawColorBoxes) {
                // Fill a white rect so that colours merge nicely if the opacity is < 1
                ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
                ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

                // Border
                ctx.lineWidth = 1;
                ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
                ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

                // Inner square
                ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
                ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
            }
            let textColor = mergeOpacity(vm.labelTextColors[i], opacity);
            ctx.fillStyle = textColor;

            fillLineOfText(line);
        });

        helpers.each(bodyItem.after, fillLineOfText);
    });

    // Reset back to 0 for after body
    xLinePadding = 0;

    // After body lines
    helpers.each(vm.afterBody, fillLineOfText);
    pt.y -= bodySpacing; // Remove last body spacing
};




// WEBPACK FOOTER //
// ./src/components/chart/ChartJsTooltipFix.js